import React from 'react'
import Modal from 'LuxKit/Modal/Modal'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import { INTL_PICKER_DATE_FORMAT } from 'constants/dateFormats'
import { useIntlDateFormatter } from 'lib/datetime/dateUtils'
import HelpPane from 'components/Common/HelpPane'

const ModalContent = styled.div`
  padding-top: ${rem(16)};
`

interface Props {
  refundable: boolean
  startDate?: moment.Moment
  cancellationPolicyDetail: string
}

function AlwaysOnOfferPropertyCancellationPolicyModal(props: Props) {
  const {
    refundable,
    cancellationPolicyDetail,
    startDate,
  } = props

  const intlDateFormatter = useIntlDateFormatter()

  return <Modal
    title={refundable ? 'Free cancellation' : 'Non refundable'}
  >
    <ModalContent>
      {(!startDate || !refundable) && (
        <BodyText variant="large" as="p">{cancellationPolicyDetail}</BodyText>
      )}
      {refundable && startDate && (
        <BodyText variant="large" as="p">Standard bookings can be cancelled with a full refund provided the cancellation made by {intlDateFormatter(startDate, INTL_PICKER_DATE_FORMAT)} 11:59 PM (local time of property).</BodyText>
      )}
      <HelpPane />
    </ModalContent>
  </Modal>
}

export default AlwaysOnOfferPropertyCancellationPolicyModal
